import 'jquery-validation';
import fetcher from 'shop-packages/redux/checkout/fetcher';
import { ApiClient } from 'shop-packages';

const paymentMethods = [
  {
      method: 'CARD',
      label: 'Kredi Kartı / Banka Kartı',
      craftgateMethodName: 'tab-content-craftgate',
  },
  {
      method: 'APM',
      label: 'Alternatif Ödeme Yöntemleri',
      isVirtual: true,
      childPaymentMethods: [
          {
              method: 'GARANTIPAY',
              label: 'GarantiPay',
              helperText: 'GarantiPay ile ödeme',
              craftgateMethodName: 'tab-content-garantipay',
          },
          {
              method: 'MULTINET',
              label: 'Multinet',
              helperText: 'Multinet ile ödeme',
              craftgateMethodName: 'tab-content-apm-multinet',
          }
      ],
  },
];

class CraftGateOption {
  constructor({pk}) {
    console.log('CraftGate: Initializing with pk:', pk);
    this.form = document.getElementById('CrafGateForm');
    this.submitButton = this.form?.querySelector('#CraftGateCompleteButton');
    this.loading = document.querySelector('.js-craftgate-loading');
    this.paymentContainer = document.querySelector('.js-craftgate-payment-container');
    this.iframeContainer = this.form?.querySelector('.js-craftgate-iframe-container');
    this.content = this.form?.querySelector('.js-craftgate-content');
    this.formError = this.form?.querySelector('.js-craftgate-iframe-error');
    this.agreementError = this.form?.querySelector('.js-crafgate-error-aggreement');
    this.agreementInput = this.form?.querySelector('.js-checkout-agreement-input');
    this.paymentMethodsContainer = document.getElementById('paymentMethods');
    this.childPaymentMethodsContainer = document.querySelector('.child-payment-methods');
    this.iframeContainerWrapper = document.querySelector('.iframe-container');
    this.paymentPk = pk;
    this.currentPaymentMethod = null;
    
    this.init();
  }

  handleLoadingIndicator = (event) => {
    const { type, value } = event.data;
    if (type === 'WAITING_FOR_RESPONSE_FROM_SERVER') {
        this.loading?.toggleAttribute('hidden', !value);
    } else if (type === 'LOAD_COMPLETED') {
        this.applyCustomCss();
        this.loading.style.display = 'none';
        this.paymentContainer.style.display = 'block';
        this.renderTabs();
        
        // Enable button as fallback after load completion
        this.enableButtonFallback();
    }
  };

  
  handleSubmitButtonState = (event) => {
    const { type, value } = event.data;
    if (type === 'SUBMIT_BUTTON_ENABLED') {
      if (this.submitButton) {
        this.submitButton.disabled = !value;
      }
    }
  };
  
  adjustIframeHeight = (event) => {
    const { type, value } = event.data;
    if (type === 'HEIGHT_CHANGED') {
      const iframe = document.getElementById('cg-iframe');
      if (iframe) {
        iframe.style.height = value + 'px';
      }
    }
  };

  applyCustomCss = () => {
    const cssRules = {
      '.environment-info': {display: "none"},
      '.tab-items': {display: "none"},
      '.tab-container': {border: "none"}
    };
    this.postMessageToIframe({
      type: 'CUSTOMIZE_UI',
      value: {cssRules: cssRules}
    });
  };

  postMessageToIframe = (message) => {
    const iframe = document.getElementById('cg-iframe');
    if (iframe && iframe.contentWindow) {
      try {
        iframe.contentWindow.postMessage(message, '*');
      } catch (error) {
        console.error('CraftGate: Error sending message to iframe:', error);
      }
    }
  };

  renderTabs = () => {
    if (!this.paymentMethodsContainer) return;
    
    this.paymentMethodsContainer.innerHTML = '';

    paymentMethods.forEach((methodObj) => {
      const btn = document.createElement('button');
      btn.className = `tab ${methodObj.method === 'CARD' ? 'active' : ''}`;
      btn.setAttribute('data-method', methodObj.method);
      btn.textContent = methodObj.label;
      this.paymentMethodsContainer.appendChild(btn);
    });

    this.paymentMethodsContainer.addEventListener('click', this.handleTabClick);
    
    // Auto-select CARD method and set as current payment method
    this.currentPaymentMethod = 'CARD';
    
    // Auto-select CARD method and enable button
    setTimeout(() => {
      this.enableButtonFallback();
    }, 500);
  };

  handleTabClick = (event) => {
    if (!event.target.classList.contains('tab')) return;
    
    // Remove active class from all tabs
    this.paymentMethodsContainer.querySelectorAll('.tab').forEach(tab => {
      tab.classList.remove('active');
    });
    
    // Add active class to clicked tab
    event.target.classList.add('active');

    const selectedMethod = event.target.getAttribute('data-method');
    const paymentMethod = paymentMethods.find(m => m.method === selectedMethod);

    if (paymentMethod.isVirtual) {
      this.renderChildPaymentMethods(paymentMethod);
    } else {
      this.handleSelectedPaymentMethod(paymentMethod);
    }
  };

  renderChildPaymentMethods = (paymentMethod) => {
    this.iframeContainerWrapper.style.display = 'none';
    this.childPaymentMethodsContainer.innerHTML = '';

    paymentMethod.childPaymentMethods.forEach(methodObj => {
      const btn = document.createElement('div');
      btn.className = 'child-payment-method';
      btn.setAttribute('data-method', methodObj.method);
      btn.setAttribute('role', 'button');
      btn.innerHTML = `
        <div>
          <div class="fw-semibold">${methodObj.label}</div>
          <small class="text-muted">${methodObj.helperText}</small>
        </div>
      `;
      this.childPaymentMethodsContainer.appendChild(btn);
    });

    this.childPaymentMethodsContainer.addEventListener('click', (e) => {
      const childMethod = e.target.closest('.child-payment-method');
      if (!childMethod) return;
      
      e.stopPropagation();
      const selectedMethod = childMethod.getAttribute('data-method');
      const selectedPaymentMethod = paymentMethod.childPaymentMethods.find(m => m.method === selectedMethod);
      this.handleSelectedPaymentMethod(selectedPaymentMethod);
    });

    this.childPaymentMethodsContainer.style.display = 'flex';
  };

  handleSelectedPaymentMethod = (paymentMethod) => {
    // Update current payment method
    this.currentPaymentMethod = paymentMethod.method;
    
    this.iframeContainerWrapper.style.display = 'block';
    this.childPaymentMethodsContainer.style.display = 'none';

    // For GarantiPay, ensure button is enabled after switching
    if (paymentMethod.method === 'GARANTIPAY') {
      setTimeout(() => {
        if (this.submitButton && this.submitButton.disabled) {
          this.submitButton.disabled = false;
        }
      }, 1000);
    }

    this.postMessageToIframe({
      type: 'OPEN_TAB',
      value: { tab: paymentMethod.craftgateMethodName }
    });
  };

  bindEvents = () => {
    window.addEventListener('message', this.adjustIframeHeight);
    window.addEventListener('message', this.handleLoadingIndicator);
    window.addEventListener('message', this.handleSubmitButtonState);
    window.addEventListener('message', this.handleAllMessages);
    if (this.agreementInput) {
      this.agreementInput.addEventListener('input', this.handleAgreementValidation);
    }
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit);
    }
  }

  handleAgreementValidation = () => {
    if (this.agreementError && this.agreementInput) {
      this.agreementError.toggleAttribute('hidden', this.agreementInput.checked);
    }
  };

  handleAllMessages = (event) => {
    const { type } = event.data;
    
    if (type === 'REDIRECT_TO_EXTERNAL_PAGE') {
      this.hidePaymentInterface();
    }
  };

  hidePaymentInterface = () => {
    // Clear redirect monitoring since we received the redirect message
    if (this.redirectMonitoringTimeout) {
      clearTimeout(this.redirectMonitoringTimeout);
    }
    
    if (this.content) {
      this.content.classList.add('payment-interface-hidden');
    }
    
    if (this.paymentMethodsContainer && this.currentPaymentMethod !== 'HEPSIPAY') {
      this.paymentMethodsContainer.classList.add('payment-interface-hidden');
    }
    
    // Ensure iframe container maintains full width
    if (this.iframeContainer) {
      this.iframeContainer.style.width = '100%';
    }
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (!this.agreementInput) {
      return;
    }

    if (!this.agreementInput.checked) {
      this.agreementError.removeAttribute('hidden');
      return;
    }
    
    try {
      this.postMessageToIframe({
        type: 'CRAFTGATE_SUBMIT_FORM'
      });
      
      // Start monitoring for redirect message with timeout
      this.startRedirectMonitoring();
      
      // Immediate hiding for GarantiPay and Hepsipay
      if (this.currentPaymentMethod === 'GARANTIPAY' || this.currentPaymentMethod === 'HEPSIPAY') {
        setTimeout(() => {
          this.hidePaymentInterface();
        }, 100);
      }
      
    } catch (error) {
      console.error('CraftGate: Error sending submit message:', error);
      this.showError('Ödeme işlemi başlatılamadı. Lütfen sayfayı yenileyin ve tekrar deneyin.');
    }
  }

    initializeLoadingState = () => {
      this.onPendingUpdate(true);
      this.iframeContainer.innerHTML = '';
      this.submitButton && (this.submitButton.disabled = true);
      this.loading.style.display = 'flex';
      this.paymentContainer.style.display = 'none';
      this.content?.setAttribute('hidden', true);
    }


   init = async () => {
    this.initializeLoadingState();

    this.paymentPk && await fetcher(ApiClient.checkout.setPaymentOption(this.paymentPk));

    const url = `${window.location.href}?${new URLSearchParams({ page: 'RedirectionPaymentSelectedPage' })}`;

    const csrf = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrftoken='))
      .split('=')[1];

    const body = new URLSearchParams({ agreement: true });

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFToken': csrf,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body
    });

    if (!response.ok) {
      this.handleIframeLoadFailure();
      return;
    }

    const data = await response.json();
    const errors = data?.errors;
    const redirectUrl = data?.context_list?.[0]?.page_context?.redirect_url;

    if (errors || !redirectUrl) {
      this.handleIframeLoadFailure();
      return;
    }

    if (redirectUrl && this.iframeContainer) {
      const urlObj = new URL(redirectUrl);
      const urlSearchParams = new URLSearchParams(urlObj.search);
      urlSearchParams.append('t', new Date().getTime());

      const iframeAttributes = {
        id: 'cg-iframe',
        className: 'js-craftgate-iframe',
        src: `${urlObj.origin}${urlObj.pathname}?${urlSearchParams.toString()}`,
        width: '100%',
        height: '600',
        frameBorder: '0',
        sandbox: 'allow-top-navigation allow-scripts allow-same-origin allow-forms',
        name: Date.now()
      };
    
      const iframe = Object.assign(document.createElement('iframe'), iframeAttributes);

      this.iframeContainer.appendChild(iframe);
      this.bindEvents();
    }

    this.loading.style.display = 'none';
    this.paymentContainer.style.display = 'block';
    this.content?.removeAttribute('hidden');
    this.renderTabs();
    
    // Start monitoring button state
    this.checkButtonStateInterval();
  }

  showError(error) {
    console.error('CraftGate: Showing error:', error);
    if (this.formError) {
      this.formError.innerHTML = error;
      this.formError.removeAttribute('hidden');
    } else {
      console.error('CraftGate: Form error element not found, showing alert instead');
      alert(error);
    }
  }

  handleIframeLoadFailure(message = 'Bir sorun oluştu, lütfen tekrar deneyin.') {
    console.error('CraftGate: Iframe load failure:', message);
    if (this.iframeContainer) {
      this.iframeContainer.innerHTML = '';
    }
    this.showError(message);
    this.onPendingUpdate(false);
    if (this.loading) {
      this.loading.style.display = 'none';
    }
    if (this.paymentContainer) {
      this.paymentContainer.style.display = 'none';
    }
    this.content?.setAttribute('hidden', true);
  }

  onPendingUpdate(isPending) {
    if (!this.submitButton) {
      return;
    }

    this.submitButton.toggleAttribute('disabled', !isPending);
  }

  enableButtonFallback = () => {
    if (this.submitButton) {
      // Force enable the button if it's still disabled after a reasonable time
      if (this.submitButton.disabled) {
        this.submitButton.disabled = false;
      }
    }
  };
  
  checkButtonStateInterval = () => {
    // Check button state every 2 seconds and enable if needed
    this.buttonCheckInterval = setInterval(() => {
      if (this.submitButton && this.submitButton.disabled) {
        const activeTab = this.paymentMethodsContainer?.querySelector('.tab.active');
        const activeMethod = activeTab?.getAttribute('data-method');
        
        if (activeMethod === 'GARANTIPAY') {
          this.submitButton.disabled = false;
        }
      }
    }, 2000);
  };

  startRedirectMonitoring = () => {
    // Clear any existing monitoring
    if (this.redirectMonitoringTimeout) {
      clearTimeout(this.redirectMonitoringTimeout);
    }
    
    // Monitor for redirect message for up to 30 seconds
    this.redirectMonitoringTimeout = setTimeout(() => {
      // Timeout reached without redirect message
    }, 30000);
  };

  unmount() {
    if (this.buttonCheckInterval) {
      clearInterval(this.buttonCheckInterval);
    }
    if (this.redirectMonitoringTimeout) {
      clearTimeout(this.redirectMonitoringTimeout);
    }
    window.removeEventListener('message', this.adjustIframeHeight);
    window.removeEventListener('message', this.handleLoadingIndicator);
    window.removeEventListener('message', this.handleSubmitButtonState);
    window.removeEventListener('message', this.handleAllMessages);
    if (this.agreementInput) {
      this.agreementInput.removeEventListener('input', this.handleAgreementValidation);
    }
    if (this.form) {
      this.form.removeEventListener('submit', this.onSubmit);
    }
  }
}

export default CraftGateOption;